import React from 'react';
import PageHero from '../components/PageHero';
import { useContent } from '../content/ContentContext';
import { useUi } from '../i18n/ui';
import { renderRich, renderMultiline } from '../utils/text';

const BODY_FALLBACK = `## 1. Premessa

I presenti Termini e Condizioni disciplinano l'utilizzo del sito di **Moto Club Insolita Sardegna** (Via Vincenzo Piro, Olbia) e la partecipazione a tour, corsi, gare ed eventi organizzati dal club. Effettuando un'iscrizione o una prenotazione dichiari di aver letto e accettato quanto segue.

## 2. Tesseramento e prenotazioni

La partecipazione alle attività può richiedere il tesseramento e/o la prenotazione del posto. Le prenotazioni si intendono confermate solo dopo la nostra conferma esplicita e, ove previsto, il versamento della caparra. I posti disponibili sono limitati: al raggiungimento della capienza massima le ulteriori richieste vengono inserite in lista d'attesa e gestite in ordine di arrivo.

## 3. Prezzi e pagamenti

I prezzi indicati per tour ed eventi si intendono per persona, salvo diversa indicazione. Il pagamento può avvenire tramite caparra online e saldo secondo le modalità comunicate. Ci riserviamo di aggiornare i prezzi; il prezzo applicato è quello valido al momento della conferma della prenotazione.

## 4. Cancellazioni e rimborsi

In caso di rinuncia da parte del partecipante, le condizioni di rimborso della caparra sono comunicate al momento della prenotazione e dipendono dall'anticipo con cui viene comunicata la cancellazione. Qualora l'attività venga annullata dal club, il partecipante ha diritto al rimborso integrale di quanto versato o alla riprogrammazione della stessa.

## 5. Requisiti di partecipazione e responsabilità

Le attività off-road, enduro e rally raid comportano rischi connaturati alla pratica sportiva. Il partecipante dichiara di essere in possesso dei requisiti necessari (patente valida ove richiesta, idoneità psicofisica, mezzo in regola e assicurato) e si impegna a:

- rispettare il codice della strada, le indicazioni delle guide e le norme di sicurezza;
- utilizzare l'abbigliamento e le protezioni adeguate;
- tenere un comportamento rispettoso dell'ambiente, dei luoghi attraversati e degli altri partecipanti.

Il club non risponde dei danni derivanti dall'inosservanza di tali obblighi o da condotte imprudenti del partecipante. Restano ferme le coperture assicurative previste per le attività.

## 6. Immagini e contenuti

Durante le attività possono essere realizzate foto e video. Salvo tua diversa comunicazione scritta, tali materiali potranno essere utilizzati dal club per finalità documentali e promozionali. Tutti i contenuti del sito (testi, immagini, loghi) sono di proprietà del club o dei rispettivi titolari e non possono essere riprodotti senza autorizzazione.

## 7. Trattamento dei dati

Il trattamento dei dati personali avviene secondo quanto descritto nella [Privacy Policy](/privacy).

## 8. Legge applicabile e foro competente

I presenti Termini sono regolati dalla legge italiana. Per ogni controversia relativa alla loro interpretazione o esecuzione sarà competente il foro del luogo in cui ha sede il club, salvo il foro inderogabile del consumatore.

## 9. Contatti

Per qualsiasi chiarimento sui presenti Termini e Condizioni puoi scriverci a info@insolitasardegna.com.`;

const Termini: React.FC = () => {
  const { t, img } = useContent();
  const { tr } = useUi();
  const title = t('legal.termini.title', 'Termini e\nCondizioni');

  return (
    <>
      <PageHero image={img('termini.hero.image', '/img/insolita-sardegna-moto.jpg')} crumb={tr('footer.termini')} title={title} minHeight="42svh" />

      <section className="sec">
        <div className="wrap">
          <div className="legal reveal">
            <p>{renderMultiline(t('legal.termini.updated', 'Ultimo aggiornamento: 7 agosto 2026'))}</p>
            {renderRich(t('legal.termini.body', BODY_FALLBACK))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Termini;
